<template>
  <v-card
    class="text-left"
    outlined
    tile
    light
  >
    <v-card-title class="text-body-1 pt-2 whitespace-wrap">{{ title }}</v-card-title>
    <v-card-text class="pb-1">{{ description }}</v-card-text>
    <v-card-actions>
      <v-btn small tile text color="primary" @click.prevent="useEvent()">USAR</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "SuggestionPreview",
  props: {
    title: {
      type: String,
      required: true,
    },
    // NOTE: Currently not in use.
    description: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    formatted_date() {
      const date = new Date(`${this.date} GMT-0300`);
      return date.toLocaleDateString();
    },
  },
  methods: {
    useEvent() {
      this.$emit("use");
    }
  }
}
</script>
<style lang="scss">
.whitespace-wrap {
    white-space: normal;
    word-break: break-word;
}
</style>
